export default __webpack_public_path__ + "static/media/Machine State, Heating.0b11f2da.png";